import { AUTH_SET_TOKEN } from '@/store/actions/auth';
import { CLEAR_SCHEDULE_QUERY } from '@/store/actions/schedule';
import { SERVER_MESSAGES_SET_TOKEN } from '@/store/actions/serverMessages';
import { DELETE_TASK_FILTER } from '@/store/actions/tasks';

/**
 * @description Страницы перенаправления на расписание.
 * @type {string[]}
 */
const REDIRECT_ROUTES_TO_SCHEDULE = [
  'ClinicPanelAppointmentScheduleEmployeePeriod',
  'ClinicPanelAppointmentScheduleEmployees',
  'ClinicPanelAppointmentScheduleCabinetPeriod',
  'ClinicPanelAppointmentScheduleCabinets',
];

/**
 * @description Страницы пациента.
 * @type {string[]}
 */
export const PATIENT_PAGES = [
  'ClinicPanelPatientBasic',
  'ClinicPanelPatientAnamnesis',
  'ClinicPanelPatientHealthQuestionnaire',
  'ClinicPanelPatientVisits',
  'ClinicPanelPatientVisit',
  'ClinicPanelPatientPlanList',
  'ClinicPanelPatientAppointments',
  'ClinicPanelPatientSnapshots',
  'ClinicPanelPatientDocuments',
  'ClinicPanelPatientInvoiceList',
  'ClinicPanelPatientAdvanceDetailList',
  'ClinicPanelPatientInvoice',
];

/**
 * @description Страницы сотрудника.
 * @type {string[]}
 */
export const EMPLOYEE_PAGES = [
  'ClinicPanelEmployeeProfileBasic',
  'ClinicPanelEmployeeProfileAdmission',
  'ClinicPanelEmployeePayrollSchema',
  'ClinicPanelEmployeeProfilePermissions',
  'ClinicPanelEmployeeProfileEgisz',
  'ClinicPanelEmployeeProfileWorkPlace',
];

/**
 * @description Запрос на смену филиала.
 * @param {number} clinicId
 * @param {number|null} employeeId
 * @param {number|null} patientId
 * @param {string} currentPage
 * @constructor
 */
function ChangeBranchRequest(
  clinicId,
  employeeId = null,
  patientId = null,
  currentPage = '',
) {
  this.clinicId = clinicId;
  this.employeeId = employeeId;
  this.patientId = patientId;
  this.currentPage = currentPage;
  this.getClinicId = () => this.clinicId;
  this.getQuery = () => ({
    employee_id: this.employeeId,
    patient_id: this.patientId,
    page: this.currentPage,
  });
}

/**
 * @description Примесь изменения филиала.
 * @type {Vue}
 */
export default {
  computed: {
    /**
     * @description Есть филиалы.
     * @returns {boolean}
     */
    hasBranchedClinics() {
      return this.branchedClinics.length > 1;
    },
    /**
     * @description Филиальная система доступна.
     * @returns {*}
     */
    areBranchAvailable() {
      return this.$store.getters.isSectionAvailable('branch-system');
    },
  },
  created() {
    if (this.areBranchAvailable) {
      this.getBranchedClinics();
    }
  },
  data() {
    return {
      /**
       * @description Филиалы.
       * @type {Array}
       */
      branchedClinics: [],
      /**
       * @description Выбранный филиал.
       * @type {null|number}
       */
      selectedBranchId: null,
    };
  },
  methods: {
    createChangeBranchRequest(clinicId) {
      const route = this.$route;
      const currentQueryId = parseInt(route.params.id, 10);
      return new ChangeBranchRequest(
        clinicId,
        EMPLOYEE_PAGES.includes(route.name) ? currentQueryId : null,
        PATIENT_PAGES.includes(route.name) ? currentQueryId : null,
        REDIRECT_ROUTES_TO_SCHEDULE.includes(route.name)
          ? '/appointment-schedule/employees'
          : route.path,
      );
    },
    /**
     * @description Получить филиалы.
     * @returns {void}
     */
    getBranchedClinics() {
      const onSuccess = ({
        branchedClinics,
        selectedBranchId,
      }) => {
        this.branchedClinics = branchedClinics;
        this.selectedBranchId = selectedBranchId;
      };
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
      };
      this
        .$userGateway
        .getBranchedClinics()
        .then((result) => result.fold(onFail, onSuccess));
    },
    /**
     * @description Обработать выбор филиала.
     * @param {number} clinicId
     */
    onSelectBranch(clinicId) {
      const request = this.createChangeBranchRequest(clinicId);
      const onSuccess = ({
        token,
        redirect,
      }) => {
        this.$store.dispatch(SERVER_MESSAGES_SET_TOKEN, '');
        this.$serverMessages.disconnect();
        this.$store.dispatch(AUTH_SET_TOKEN, token);
        this.$store.dispatch(DELETE_TASK_FILTER);
        this.routeTo(redirect);
      };
      const onFail = (error) => {
        this.notifyFail(error);
      };
      this
        .$userGateway
        .changeUserBranch(request.getClinicId(), request.getQuery())
        .then((result) => result.fold(onFail, onSuccess));
    },
    /**
     * @description Перейти к расписанию.
     * @returns {void}
     */
    async routeTo(to) {
      await this.$store.dispatch(CLEAR_SCHEDULE_QUERY);
      if (to !== this.$route.path) {
        await this.$router.push(to);
      }
      window.location.reload();
    },
  },
};
